/**
 * Header.tsx — 顶部导航（Logo + 搜索 + 导航链接）
 */
import { Link, NavLink } from 'react-router-dom';
import SearchBar from './SearchBar';
import { LogoIcon } from './Icons';

/** NavLink 激活样式 */
function navClass({ isActive }: { isActive: boolean }): string {
  return isActive
    ? 'rounded-lg bg-slate-100 px-3 py-1.5 text-slate-900'
    : 'rounded-lg px-3 py-1.5 text-slate-500 hover:bg-slate-100 hover:text-slate-900';
}

export default function Header() {
  return (
    <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/90 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-6xl items-center gap-4 px-4">
        <Link to="/" className="flex shrink-0 items-center gap-2 text-lg font-bold text-slate-900">
          <LogoIcon />
          <span>PromptHub</span>
        </Link>

        <div className="hidden flex-1 md:block">
          <SearchBar />
        </div>

        <nav className="ml-auto flex shrink-0 items-center gap-1 text-sm font-medium">
          <NavLink to="/" end className={navClass}>
            首页
          </NavLink>
          <NavLink to="/submit" className={navClass}>
            提交
          </NavLink>
          <NavLink to="/subscribe" className={navClass}>
            订阅
          </NavLink>
        </nav>
      </div>

      {/* 移动端搜索栏 */}
      <div className="px-4 pb-3 md:hidden">
        <SearchBar />
      </div>
    </header>
  );
}
